import React, { PropsWithChildren } from 'react';
import { Layout } from 'antd';
import Logo from '../../assets/images/Logo.png';

const AbandonedBusinessLayout: React.FC<PropsWithChildren> = ({ children }) => (
  <Layout className='ab-layout'>
    <div className='ab-header'>
      <img className='ab-logo' src={Logo} alt='FeelEat Logo' />
    </div>
    <Layout.Content>
      <div className='ab-content'>{children}</div>
    </Layout.Content>
    <Layout.Footer className='ab-footer'>
      FEEL EAT &copy;{new Date().getFullYear()}
    </Layout.Footer>
  </Layout>
);

export default AbandonedBusinessLayout;

